//LazyLoad
//Appel Lozad
$( document ).ready(function() {
    const observer = lozad();
    observer.observe();
});
